import { IApiService } from 'web_core_library';
import { IHostedPageResponse } from './types';

export function getCheckoutService() {
  let ApiService: IApiService;

  const getCheckoutUrl = (
    planId: string,
    productId: string,
    locale: string,
    country: string,
    coupon: string,
    email: string
  ) => {
    const couponId = coupon === '' ? undefined : coupon;
    return ApiService.action<IHostedPageResponse>('checkout_complete_v2', {
      method: 'get',
      urlParams: {
        userId: ApiService.getUserId(),
        product: planId,
      },
      params: {
        country,
        couponId,
        locale,
        productId,
        email,
      },
    });
  };

  return {
    init: (ApiServiceInstance: IApiService) => {
      ApiService = ApiServiceInstance;
    },
    getCheckoutUrl,
  };
}

const checkoutService = getCheckoutService();
export default checkoutService;
